import Unauthorized from './unauthorized.tsx';

export default Unauthorized;